<template>
  <v-footer app :inset="true" elevation="12" class="overline">
    <v-spacer />

    <span style="font-size: 0.625rem">
      {{ appName }} © {{ new Date().getFullYear() }}
    </span>

    <v-spacer />

    <v-btn x-small text href="https://kinetics.co.ke/" target="_blank">
      Kinetics Technology LTD
      <v-icon x-small right> mdi-open-in-new </v-icon>
    </v-btn>
  </v-footer>
</template>

<script>
import { appName } from "../environment";
import { AuthService } from "../modules/auth";

export default {
  name: "FooterComponent",
  props: {
    opacity: {
      type: String,
      default: "1",
    },
  },

  mounted() {
    this.$store.dispatch("Dashboard/getCompanies");
  },

  computed: {
    appName() {
      return appName;
    },

    company() {
      return AuthService.company;
    },

    companies() {
      return this.$store.getters["Dashboard/companies"];
    },
    intakePeriod() {
      return this.$store.getters["Dashboard/intakePeriods"].filter(
        (period) => period.current,
      )[0];
    },
  },

  methods: {
    setCompany: function (company) {
      if (AuthService.check()) {
        this.$store.dispatch("Auth/setCompany", {
          default_company: company.id,
        });
      } else {
        AuthService.setCompany(company);
      }
    },
  },
};
</script>

<style scoped></style>
